var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    {
      staticClass: "flash-betting-holder",
      class: { "flash-betting-holder-betzone": _vm.isFlashBettingOnBetZone },
      model: {
        value: _vm.computedExpansionPanel,
        callback: function($$v) {
          _vm.computedExpansionPanel = $$v
        },
        expression: "computedExpansionPanel"
      }
    },
    [
      _c(
        "v-expansion-panel-content",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c("div", { staticClass: "flash-betting-expansion-header" }, [
                    _c("div", { staticClass: "left-section" }, [
                      _c("span", { staticClass: "flash-betting-icon" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "flash-betting-title" }, [
                        _vm._v(_vm._s(_vm.$t("FlashBetting.Title")))
                      ])
                    ])
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _vm.hasFlashMarkets
            ? _c(
                "v-card",
                { staticClass: "flash-betting-markets" },
                [
                  _vm.isFlashBettingOnBetZone
                    ? _vm._l(_vm.flashBettingEvents, function(
                        item,
                        eventIndex
                      ) {
                        return _c(
                          "div",
                          {
                            key:
                              item.event.idfoevent ||
                              "flash-event-" + eventIndex,
                            staticClass: "flash-betting-event-group"
                          },
                          [
                            _c("h3", [_vm._v(_vm._s(item.event.eventname))]),
                            _vm._v(" "),
                            _vm.getBetZoneVisibleMarkets(item, eventIndex)
                              .length
                              ? _vm._l(
                                  _vm.getBetZoneVisibleMarkets(
                                    item,
                                    eventIndex
                                  ),
                                  function(market, marketIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key:
                                          market.idfomarket ||
                                          "market-" + marketIndex,
                                        staticClass: "flash-betting-container",
                                        style: _vm.getBetZoneCardStyles(
                                          marketIndex
                                        )
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flash-betting-markets-header"
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "flash-betting-indicator"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "flash-betting-skip",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.skipBetZoneMarket(
                                                      item,
                                                      eventIndex
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("SKIP")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flash-betting-markets-title"
                                          },
                                          [_vm._v(_vm._s(market.name))]
                                        ),
                                        _vm._v(" "),
                                        market &&
                                        market.externaldescription &&
                                        market.externaldescription !==
                                          market.name
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "constraint-text"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      market.externaldescription
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("markets", {
                                          attrs: {
                                            event: item.event,
                                            markets: [market],
                                            hasFlashBettingMarket: true
                                          }
                                        }),
                                        _vm._v(" "),
                                        market && market.webnote
                                          ? _c(
                                              "div",
                                              { staticClass: "context-note" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(market.webnote) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  }
                                )
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "currently-empty" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "currently-empty-container"
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "currently-empty-icon"
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "currently-empty-text" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("FlashBetting.Empty")
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      })
                    : _vm._l(_vm.visibleMarkets.filter(Boolean), function(
                        market,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            key: market.idfomarket || "market-" + index,
                            staticClass: "flash-betting-container",
                            class: {
                              skipping: _vm.skippedMarket === market.idfomarket
                            },
                            style: _vm.cardStyles[index],
                            on: {
                              transitionend: function($event) {
                                return _vm.resetSkip(market.idfomarket)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flash-betting-markets-header" },
                              [
                                _c("span", {
                                  staticClass: "flash-betting-indicator"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "flash-betting-skip",
                                    on: {
                                      click: function($event) {
                                        return _vm.skip(market.idfomarket)
                                      }
                                    }
                                  },
                                  [_vm._v("SKIP")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flash-betting-markets-title" },
                              [_vm._v(_vm._s(market.name))]
                            ),
                            _vm._v(" "),
                            market &&
                            market.externaldescription &&
                            market.externaldescription !== market.name
                              ? _c("div", { staticClass: "constraint-text" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(market.externaldescription) +
                                      "\n          "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("markets", {
                              attrs: {
                                event: _vm.flashBettingMarkets,
                                markets: [market],
                                hasFlashBettingMarket: true
                              }
                            }),
                            _vm._v(" "),
                            market && market.webnote
                              ? _c("div", { staticClass: "context-note" }, [
                                  _vm._v(_vm._s(market.webnote))
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      })
                ],
                2
              )
            : _c("div", { staticClass: "currently-empty" }, [
                _c("div", { staticClass: "currently-empty-container" }, [
                  _c("div", { staticClass: "currently-empty-icon" })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "currently-empty-text" }, [
                  _vm._v(_vm._s(_vm.$t("FlashBetting.Empty")))
                ])
              ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c51e421", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c51e421","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/FlashBetting.vue
// module id = null
// module chunks = 